module.exports = __webpack_public_path__ + "static/media/network.c19fb1cf.svg";